export const POINTER_COLORS: Record<string, { bg: string; border: string; text: string; arrow: string }> = {
  i: { bg: '#3b82f620', border: '#3b82f6', text: '#3b82f6', arrow: '#3b82f6' },
  j: { bg: '#ec489920', border: '#ec4899', text: '#ec4899', arrow: '#ec4899' },
  left: { bg: '#10b98120', border: '#10b981', text: '#10b981', arrow: '#10b981' },
  right: { bg: '#f59e0b20', border: '#f59e0b', text: '#f59e0b', arrow: '#f59e0b' },
  head: { bg: '#8b5cf620', border: '#8b5cf6', text: '#8b5cf6', arrow: '#8b5cf6' },
  tail: { bg: '#f43f5e20', border: '#f43f5e', text: '#f43f5e', arrow: '#f43f5e' },
  curr: { bg: '#06b6d420', border: '#06b6d4', text: '#06b6d4', arrow: '#06b6d4' },
  prev: { bg: '#64748b20', border: '#64748b', text: '#64748b', arrow: '#64748b' },
  kth: { bg: '#8b5cf620', border: '#8b5cf6', text: '#8b5cf6', arrow: '#8b5cf6' },
  low: { bg: '#06b6d420', border: '#06b6d4', text: '#06b6d4', arrow: '#06b6d4' },
  high: { bg: '#f4364720', border: '#f43647', text: '#f43647', arrow: '#f43647' },
  mid: { bg: '#a855f720', border: '#a855f7', text: '#a855f7', arrow: '#a855f7' },
};

export const DEFAULT_PTR_COLOR = { bg: '#6366f120', border: '#6366f1', text: '#6366f1', arrow: '#6366f1' };

export function getPointerColor(label: string) {
  const key = label.replace(/[^a-zA-Z]/g, '').toLowerCase();
  return POINTER_COLORS[key] || DEFAULT_PTR_COLOR;
}
